module.exports = __webpack_public_path__ + "img/1.98c19ffe.jpg";